<template>
  <main class="a-layout-inner a-content">
    <slot></slot>
  </main>
</template>

<style lang="scss">
.a-content {
  flex: auto;
  box-sizing: border-box;
}
</style>
